module.exports = __webpack_public_path__ + "static/media/whiteboard.4213133c.png";